import styled from "styled-components";
import { IconButton } from "cdk-radial";

export const ReverseIconButton = styled(IconButton)`
  &&& > svg {
    fill: #fff;
  }
`;
